export default __webpack_public_path__ + "static/media/33-min.5ee32dc7.png";